import { useEmbedContext } from '@thoughtspot/blink-context';
import cx from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React, { useEffect, useRef } from 'react';
import styles from '../layout.module.scss';
export var ContentWidth;
(function (ContentWidth) {
    ContentWidth["FLUID"] = "fluidWidth";
    ContentWidth["FIXED"] = "fixedWidth";
})(ContentWidth || (ContentWidth = {}));
export const Content = ({ children, contentWidth = ContentWidth.FLUID, noPadding = false, disableOverlayScroll = false, shouldScrollOnChildrenChange = false, className = '', }) => {
    const contentDivRef = useRef(null);
    const { isEmbedded, embedParams } = useEmbedContext();
    // In a full height embed the iframe is resized to the height measured off
    // the page, so nothing here has a definite height to size against. The
    // overlay scrollbars then prop their host open with a glue element sized to
    // `max(contentHeight, hostHeight)` — grow-only — which hands the height we
    // just reported back as content, so the page can never shrink and keeps
    // absorbing the buffer added to every reported height (SCAL-327607). The
    // native branch has no glue element, so the measurement stays honest.
    const isFullHeightEmbed = !!isEmbedded && !!(embedParams === null || embedParams === void 0 ? void 0 : embedParams.isFullHeightPinboard);
    const useNativeScroll = disableOverlayScroll || isFullHeightEmbed;
    useEffect(() => {
        var _a;
        if (shouldScrollOnChildrenChange)
            (_a = contentDivRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    }, [children, shouldScrollOnChildrenChange]);
    const innerContainerClass = cx(styles.innerContainer, {
        [styles.fixedWidth]: contentWidth === ContentWidth.FIXED,
        [styles.noPadding]: noPadding,
        [className]: className !== '',
    });
    const pageContent = (React.createElement("main", { className: styles.page },
        React.createElement("div", { className: innerContainerClass }, children)));
    return useNativeScroll ? (React.createElement("div", { "data-testid": "content", className: styles.contentNonOverlayScroll, ref: contentDivRef }, pageContent)) : (React.createElement(OverlayScrollbarsComponent, { options: {
            scrollbars: { autoHide: 'move' },
        }, className: cx('os-host-flexbox', styles.contentOverlayScroll) }, pageContent));
};
//# sourceMappingURL=content.js.map